export enum ListingTypeEnum {
    RENT = 'RENT',
    SALE = 'SALE',
}
